import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

// Props aren't used, but prevent errors
const styles: ComponentStylesProps<string> = {
  mainTitleSection: {
    marginBottom: '5rem',
    [breakpoints.sm.down]: {
      marginBottom: '3rem',
      paddingBottom: '3rem',
      borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    },
  },
  additionalTitleSections: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '3rem',
    paddingBottom: '3rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    [breakpoints.sm.down]: {
      flexDirection: 'column',
      gap: '2rem',
    },
  },
  additionalSection: {
    maxWidth: '45%',
    '&:first-child': {
      marginRight: '3rem',
      paddingRight: '3rem',
      borderRight: `0.1rem solid ${colors.neutral[300]}`,
    },
    [breakpoints.sm.down]: {
      maxWidth: '100%',
      '&:first-child': {
        marginRight: 0,
        paddingRight: 0,
        borderRight: 'none',
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
